<template>
  <a-social-sharing
    hashtags="investingLive"
    twitter-user="investinglive"
    network="whatsapp"
    :url="sharingUrl"
    :title="title"
    :description="description"
    :quote="title"
    :open-in-iframe="openInIframe"
  >
    <a-icon
      v-bind="$attrs"
      is-button
      tabindex="-1"
      :icon="$attrs.icon || ICON.WHATSUP_ROUND_BLACK"
    />
  </a-social-sharing>
</template>

<script>
import socialSharing from '../socialSharing'

export default {
  name: 'WhatsApp',
  mixins: [socialSharing]
}
</script>
